import React from 'react';
import backgroundSecundario from '../assets/images/Background/backgroundSecundario.png'

const BemVindo = (props) => <img src={backgroundSecundario} style={{ maxWidth: "100%", display: 'block'}} alt="Por onde vamos começar?" />

export default BemVindo;